{
  "tasks": {
    "title": "Tâches",
    "description": "Tâches qu'un collègue ou une application vous a confiées",
    "columns": {
      "title": "Tâche",
      "createdBy": "Créée par",
      "dueAt": "Échéance",
      "source": "Référence"
    },
    "markDone": "Terminé",
    "openSource": "Ouvrir",
    "empty": "Aucune tâche ouverte",
    "search": "Rechercher des tâches...",
    "completed": "« {{title}} » terminée",
    "completeFailed": "La tâche n'a pas pu être terminée",
    "review": "Voir"
  },
  "myTasks": {
    "title": "Mes tâches",
    "description": "Tout ce qui attend actuellement votre action",
    "openProcessesTitle": "Processus ouverts",
    "openProcessesDescription": "Processus sous votre responsabilité dont vous n'avez pas encore commencé l'enregistrement",
    "inProgressRecordingsTitle": "Enregistrements en cours",
    "inProgressRecordingsDescription": "Étapes de processus que vous avez commencé à décrire mais pas encore terminées",
    "assignmentsTitle": "Mes attributions",
    "assignmentsDescription": "Étapes de processus qui vous ont été attribuées et qui attendent votre intervention.",
    "pendingSurveysTitle": "Enquêtes en attente",
    "pendingSurveysDescription": "Donnez votre avis sur vos étapes de processus enregistrées",
    "pendingReviewsTitle": "Revues en attente",
    "pendingReviewsDescription": "Approuvez ou rejetez les systèmes et fonctions proposés pendant l'enregistrement",
    "noPendingReviews": "Aucune revue en attente",
    "searchPendingReviews": "Rechercher des revues...",
    "review": "Examiner",
    "kind": "Type",
    "name": "Nom",
    "submittedBy": "Soumis par",
    "source": "Proposé dans",
    "submittedAt": "Soumis",
    "openSourceRecording": "Ouvrir l'enregistrement",
    "unnamedProcess": "Processus sans nom",
    "process": "Processus",
    "department": "Département",
    "processOwner": "Propriétaire du processus",
    "processStep": "Étape de processus",
    "previousProcessStep": "Étape de processus précédente",
    "processStart": "Début du processus",
    "processStepGeneric": "Étape de processus",
    "newStep": "Nouvelle attribution d'étape",
    "unclearResolution": "Prochain responsable incertain",
    "decisionStep": "Étape de décision",
    "dueDate": "Date d'échéance",
    "startedDate": "Date de début",
    "assignedBy": "Assigné par",
    "startRecording": "Démarrer l'enregistrement",
    "completeSurvey": "Compléter l'enquête",
    "noOpenProcesses": "Aucun processus ouvert trouvé",
    "noInProgressRecordings": "Aucun enregistrement en cours trouvé",
    "noAssignments": "Aucune attribution en attente trouvée",
    "noPendingSurveys": "Aucune enquête en attente trouvée",
    "searchInProgressRecordings": "Rechercher des enregistrements...",
    "searchSurveys": "Rechercher des enquêtes...",
    "searchOpenProcesses": "Rechercher des processus...",
    "searchAssignments": "Rechercher des attributions...",
    "noTasksTitle": "Toutes les tâches sont terminées !",
    "noTasksDescription": "Rien ne vous attend pour le moment. Les nouvelles tâches apparaîtront automatiquement ici.",
    "variantAnswerSaved": "Réponse enregistrée",
    "variantAnswerFailed": "Échec de l'enregistrement de votre réponse",
    "surveySubmitFailed": "Échec de la soumission de l'enquête"
  },
  "assignmentReview": {
    "previousStep": "Étape précédente",
    "outputLabel": "Sortie :",
    "stepInfoUnavailable": "Informations sur l'étape non disponibles",
    "accept": "M'assigner",
    "deny": "Ne pas m'assigner",
    "successAcceptedTitle": "Vous avez été assigné(e) avec succès !",
    "successAcceptedDesc": "Vous pouvez maintenant commencer à décrire votre étape de processus.",
    "successRejectedTitle": "Merci pour votre retour !",
    "successRejectedDesc": "L'étape de processus sera réattribuée.",
    "finish": "Terminer",
    "mergeSectionTitle": "Cette étape existe peut-être déjà dans ce processus",
    "mergeSectionDescription": "Au lieu d'enregistrer depuis le début, vous pouvez fusionner cette attribution avec une étape existante.",
    "mergeInto": "Fusionner avec cette étape",
    "mergeConfirmTitle": "Fusionner l'attribution ?",
    "mergeConfirmDescription": "Cette attribution sera liée à \"{{stepName}}\" au lieu de créer un nouvel enregistrement. Cette action est irréversible.",
    "mergeConfirm": "Fusionner",
    "mergeCancel": "Annuler",
    "mergeError": "Échec de la fusion de l'attribution",
    "unnamedStep": "Étape sans nom",
    "selectMergeCandidate": "Sélectionner une étape pour la fusion…",
    "searchMergeCandidates": "Rechercher des étapes…",
    "noMergeCandidates": "Aucune étape correspondante trouvée.",
    "systemAssigneeHintTitle": "Cette étape est exécutée par un système",
    "systemAssigneeHintDescription": "Vous êtes désigné comme responsable de ce système. Décrivez ce que fait le système, et non ce que vous faites vous-même.",
    "externalContactAssigneeHintTitle": "Cette étape est exécutée par un contact externe",
    "externalContactAssigneeHintDescription": "Vous enregistrez cette étape en son nom. Décrivez ce que fait le contact externe — pas ce que vous faites vous-même."
  },
  "reassignContext": {
    "title": "Attribuer le prochain responsable",
    "descriptionPending": "Choisissez un·e nouveau·elle assigné·e — ou marquez l'étape comme incertaine si l'on ne sait pas encore qui s'en chargera.",
    "descriptionPendingUnclear": "Résolvez l'attribution incertaine : choisissez qui prend en charge la prochaine étape.",
    "descriptionRecording": "Choisissez un·e nouveau·elle assigné·e — ou marquez l'étape comme incertaine si l'on ne sait pas encore qui s'en chargera.",
    "unclearAlertTitle": "Attribution marquée comme incertaine",
    "unclearAlertDescription": "Cette attribution vous a été confiée en tant que propriétaire du processus, car il n'a pas été précisé lors de l'enregistrement qui prend en charge la prochaine étape. Vérifiez les détails de l'étape et attribuez un prochain responsable.",
    "markedUnclearBy": "Marqué·e comme incertain·e par",
    "stepDetails": "Détails de l'étape",
    "currentStep": "Étape en cours de réassignation",
    "assignToHeading": "Assigner à",
    "chooseAssignee": "Sélectionner une personne, une fonction ou un système",
    "markedUnclear": "Marquée comme incertaine",
    "confirm": "Continuer"
  },
  "celebration": {
    "banner": {
      "title": "Merci pour votre engagement !",
      "description_one": "Vous venez de terminer 1 tâche.",
      "description_other": "Vous venez de terminer {{count}} tâches.",
      "doneCount": "Terminées : {{count}}",
      "openCount": "Ouvertes : {{count}}"
    },
    "recordingStarted": {
      "title": "Enregistrement lancé !",
      "description": "« {{process}} » est en cours : les premiers participants sont invités et décrivent maintenant leurs étapes."
    },
    "survey": {
      "title": "Merci pour votre retour !",
      "remaining_one": "Encore 1 enquête en attente – elle prend environ une minute.",
      "remaining_other": "Encore {{count}} enquêtes en attente – chacune prend environ une minute.",
      "allDone": "Toutes les enquêtes sont terminées. Votre équipe sait maintenant comment le travail se déroule réellement.",
      "nextSurvey": "Enquête suivante"
    },
    "step": {
      "title": "C'est fait !",
      "description": "Votre étape fait désormais partie de « {{process}} ». Merci de partager vos connaissances !",
      "startSurvey": "Lancer une courte enquête (env. 1 min)"
    },
    "toTasks": "Aller à mes tâches",
    "later": "Plus tard"
  },
  "approvals": {
    "status": {
      "approved": "Validé",
      "executed": "Exécuté",
      "rejected": "Refusé",
      "overridden": "Poursuivi sans validation",
      "withdrawn": "Retiré",
      "pending": "Ouvert"
    },
    "card": {
      "progress": "{{count}} sur {{total}} validé(s)",
      "requestedBy": "Demandé par {{name}} le {{date}}",
      "due": "échéance {{date}}",
      "reviewers": "Valideurs",
      "reviewersNeeded_one": "{{count}} sur {{total}} doit valider",
      "reviewersNeeded_other": "{{count}} sur {{total}} doivent valider",
      "verdict": {
        "open": "en attente",
        "approved": "a validé ({{date}})",
        "rejected": "a refusé ({{date}})"
      },
      "overriddenBy": "{{name}} a poursuivi sans validation ({{date}})",
      "rejectReason": "Motif du refus",
      "rejectReasonPlaceholder": "Pourquoi ? Le demandeur lira le motif.",
      "approve": "Valider",
      "reject": "Refuser",
      "confirmReject": "Refuser avec motif",
      "withdraw": "Retirer",
      "openRecord": "Ouvrir",
      "override": "Poursuivre sans validation"
    },
    "override": {
      "title": "Poursuivre sans validation ?",
      "warning": "Le principe des quatre yeux est contourné. Les valideurs sont informés et la demande est consignée comme ignorée.",
      "confirm": "Poursuivre sans validation",
      "reason": "Motif",
      "reasonPlaceholder": "Pourquoi ne peut-on pas attendre ?"
    },
    "recipients": {
      "intro_one": "Cette personne reçoit une tâche :",
      "intro_other": "Ces {{count}} personnes reçoivent une tâche :",
      "due": "Échéance le {{date}}.",
      "required": "{{count}} sur {{total}} doivent valider."
    },
    "dialogTitle": "Validation",
    "actionFailed": "L'action a échoué",
    "toast": {
      "approved": "Validé",
      "rejected": "Refusé",
      "overridden": "Poursuivi sans validation",
      "withdrawn": "Retiré"
    },
    "title": "Validations",
    "descriptionAll": "Toutes les validations de l'espace de travail",
    "descriptionMine": "Validations que vous avez demandées ou que vous examinez",
    "empty": "Aucune validation",
    "search": "Rechercher des validations",
    "columns": {
      "label": "Objet",
      "status": "Statut",
      "requestedBy": "Demandé par",
      "reviewers": "Valideurs",
      "requestedAt": "Demandé le"
    }
  }
}
